import * as mt from "./mutation-types";


import { Analysis, AreaExpansionChartDTO, ScoreAreaComparativeDTO, ComparativeScoreChartDTO, YieldByYearDTO, AnalysisSummaryDTO, CropsStagesDTO, AnalysisYieldEvolutionDTO, LastYearYieldDTO } from "@/api/analyses/types";
import { RootState } from "../types";
import { AnalysesState } from "./types";
import { ActionContext } from "vuex";

export default {
  [mt.CLEANUP]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.CLEANUP);
  },
  [mt.ANALYSES_REQUEST]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.ANALYSES_REQUEST);
  },

  [mt.ANALYSES_REQUEST_SUCCESS](
    { commit }: ActionContext<AnalysesState, RootState>, analysis: Analysis
  ) {
    commit(mt.ANALYSES_REQUEST_SUCCESS, { analysis });
  },

  [mt.ANALYSES_REQUEST_ERROR]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.ANALYSES_REQUEST_ERROR);
  },
  [mt.CREATE_ANALYSIS_REQUEST]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.CREATE_ANALYSIS_REQUEST);
  },
  [mt.CREATE_ANALYSIS_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.CREATE_ANALYSIS_SUCCESS);
  },
  [mt.CREATE_ANALYSIS_FAILURE]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.CREATE_ANALYSIS_FAILURE);
  },
  [mt.DELETE_ANALYSIS_FAILURE]({ commit }: ActionContext<AnalysesState, RootState>, analysis: Analysis) {
    commit(mt.DELETE_ANALYSIS_FAILURE, { analysis });
  },
  [mt.FETCHING_AREA_EXPANSION_DTO] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCHING_AREA_EXPANSION_DTO);
  },
  [mt.FETCH_AREA_EXPANSION_DTO_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: AreaExpansionChartDTO[]) {
    commit(mt.FETCH_AREA_EXPANSION_DTO_SUCCESS,  dto );
  },
  [mt.FETCH_AREA_EXPANSION_DTO_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_AREA_EXPANSION_DTO_FAILED);
  },
  [mt.FETCHING_YIELD_BY_YEAR_DTO] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCHING_YIELD_BY_YEAR_DTO);
  },
  [mt.FETCH_YIELD_BY_YEAR_DTO_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: YieldByYearDTO[]) {
    commit(mt.FETCH_YIELD_BY_YEAR_DTO_SUCCESS,  dto );
  },
  [mt.FETCH_YIELD_BY_YEAR_DTO_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_YIELD_BY_YEAR_DTO_FAILED);
  },
  [mt.FETCH_COMPARATIVE_SCORE_REQUEST] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_COMPARATIVE_SCORE_REQUEST);
  },
  [mt.FETCH_COMPARATIVE_SCORE_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: ComparativeScoreChartDTO[]) {
    commit(mt.FETCH_COMPARATIVE_SCORE_SUCCESS,  dto );
  },
  [mt.FETCH_COMPARATIVE_SCORE_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_COMPARATIVE_SCORE_FAILED);
  },

  [mt.FETCH_ANALYSIS_SUMMARY_REQUEST] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_SUMMARY_REQUEST);
  },
  [mt.FETCH_ANALYSIS_SUMMARY_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: AnalysisSummaryDTO[]) {
    commit(mt.FETCH_ANALYSIS_SUMMARY_SUCCESS,  dto );
  },
  [mt.FETCH_ANALYSIS_SUMMARY_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_SUMMARY_FAILED);
  },

  [mt.FETCH_ANALYSIS_CROPS_STAGES_REQUEST] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_CROPS_STAGES_REQUEST);
  },
  [mt.FETCH_ANALYSIS_CROPS_STAGES_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: CropsStagesDTO[]) {
    commit(mt.FETCH_ANALYSIS_CROPS_STAGES_SUCCESS,  dto );
  },
  [mt.FETCH_ANALYSIS_CROPS_STAGES_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_CROPS_STAGES_FAILED);
  },

  [mt.FETCH_ANALYSIS_YIELD_EVOLUTION_REQUEST] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_YIELD_EVOLUTION_REQUEST);
  },
  [mt.FETCH_ANALYSIS_YIELD_EVOLUTION_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: AnalysisYieldEvolutionDTO[]) {
    commit(mt.FETCH_ANALYSIS_YIELD_EVOLUTION_SUCCESS,  dto );
  },
  [mt.FETCH_ANALYSIS_YIELD_EVOLUTION_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_ANALYSIS_YIELD_EVOLUTION_FAILED);
  },

  [mt.FETCH_LAST_YEAR_YIELD_REQUEST] ({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_LAST_YEAR_YIELD_REQUEST);
  },
  [mt.FETCH_LAST_YEAR_YIELD_SUCCESS]({ commit }: ActionContext<AnalysesState, RootState>, dto: LastYearYieldDTO) {
    commit(mt.FETCH_LAST_YEAR_YIELD_SUCCESS,  dto );
  },
  [mt.FETCH_LAST_YEAR_YIELD_FAILED]({ commit }: ActionContext<AnalysesState, RootState>) {
    commit(mt.FETCH_LAST_YEAR_YIELD_FAILED);
  },
};
